// Dev seed data — used on localhost only. Never touches Azure Blob Storage.
// Edit this file to change the initial device set that loads in dev.
// To reset to seed data: clear localStorage key "owl-dev-state" in DevTools.

const SEED_DATE = "2026-01-01T00:00:00.000Z";

const seedDevices = [
  { serial: "43000125", deviceId: "12881426" },
  { serial: "43000117", deviceId: "12881253" },
  { serial: "43000090", deviceId: "12881511" },
  { serial: "43000092", deviceId: "12881186" },
  { serial: "43000058", deviceId: "12881396" },
  { serial: "43000084", deviceId: "12881272" },
  { serial: "43000134", deviceId: "12881570" },
  { serial: "43000067", deviceId: "12881405" },
  { serial: "43000133", deviceId: "12881354" },
  { serial: "43000130", deviceId: "12881549" },
  { serial: "43000128", deviceId: "12881541" },
  { serial: "43000073", deviceId: "12881346" },
  { serial: "43000072", deviceId: "12881415" },
  { serial: "43000149", deviceId: "12881533" },
].map((d, i) => ({
  id: 1000 + i,
  serial: d.serial,
  type: "RH2",
  status: "Not Started",
  added: SEED_DATE,
  deviceId: d.deviceId,
  simType: "Webbing",
  simType2: "Webbing",
  firmware: "",
  purchaseDate: "2026-01-01",
  location: "In Stock",
  locationLog: [{ from: null, to: "In Stock", date: SEED_DATE, by: "Dev Seed" }],
}));

// ─── RMA seed ────────────────────────────────────────────────────────────────
// Devices in each RMA state, so the RMA screens have something to render in dev.
// Ids continue on from seedDevices (1000+).
const iso = (daysAgo) => new Date(Date.parse("2026-08-27T09:00:00.000Z") - daysAgo * 86400000).toISOString();

const rmaDevice = (id, serial, deviceId, status, extra = {}) => ({
  id, serial, type: "RH2", status, location: status,
  added: SEED_DATE, deviceId, simType: "Webbing", simType2: "Webbing", firmware: "",
  purchaseDate: "2026-01-01",
  locationLog: [{ from: null, to: "In Stock", date: SEED_DATE, by: "Dev Seed" },
                { from: "In Stock", to: status, date: iso(30), by: "Dev Seed" }],
  ...extra,
});

const seedRmaDevices = [
  // On RMA-2026-001 (with manufacturer, over SLA)
  rmaDevice(2001, "43000201", "12881601", "With Manufacturer"),
  rmaDevice(2002, "43000214", "12881602", "With Manufacturer"),
  // On RMA-2026-002 (awaiting dispatch)
  rmaDevice(2003, "43000220", "12881603", "Pending RMA"),
  // On the legacy-shaped record, to prove the mergeState migration
  rmaDevice(2004, "43000277", "12881604", "With Manufacturer"),
  // Failed goods-inwards QC, not yet on any RMA — drives the batch staging section
  rmaDevice(2010, "43000811", "12881610", "Pending RMA", {
    importBatch: "PO-12480",
    quarantineFailedChecks: ["Buttons", "Haptics"],
    quarantineNote: "Right button dead out of the box, no haptic response",
    quarantineDate: iso(3),
    qc: { sessionId: "qcs-seed-1", result: "fail", failedChecks: ["Buttons", "Haptics"], note: "Right button dead out of the box, no haptic response", checkedAt: iso(3), by: "Dev Seed" },
  }),
  rmaDevice(2011, "43000814", "12881611", "Pending RMA", {
    importBatch: "PO-12480",
    quarantineFailedChecks: ["Charging"],
    quarantineNote: "Will not charge from supplied cable or bench PSU",
    quarantineDate: iso(3),
    qc: { sessionId: "qcs-seed-1", result: "fail", failedChecks: ["Charging"], note: "Will not charge from supplied cable or bench PSU", checkedAt: iso(3), by: "Dev Seed" },
  }),
  rmaDevice(2012, "43000769", "12881612", "Pending RMA", {
    importBatch: "PO-12461",
    quarantineFailedChecks: ["Powers on"],
    quarantineNote: "Dead on arrival, no response on charge",
    quarantineDate: iso(16),
    qc: { sessionId: "qcs-seed-2", result: "fail", failedChecks: ["Powers on"], note: "Dead on arrival, no response on charge", checkedAt: iso(16), by: "Dev Seed" },
  }),
  // Field quarantine — mixed warranty positions drive the ordering and colouring
  rmaDevice(2020, "43000068", "12881620", "Quarantine", {
    quarantineFailedChecks: ["Other"], quarantineNote: "Right LED plays up when showing white",
    quarantineDate: iso(9), wasQuarantined: true, purchaseDate: "2025-11-01",
  }),
  rmaDevice(2021, "43000159", "12881621", "Quarantine", {
    quarantineFailedChecks: ["Haptics"], quarantineNote: "Haptics not working and will not connect to RTK",
    quarantineDate: iso(5), wasQuarantined: true, purchaseDate: "2024-06-01", // out of warranty
  }),
  rmaDevice(2022, "43000091", "12881622", "Quarantine", {
    quarantineFailedChecks: ["Charge port"], quarantineNote: "Will not charge from mains or laptop",
    quarantineDate: iso(2), wasQuarantined: true, purchaseDate: "2026-03-01",
  }),
];

const seedRmaShipments = [
  {
    id: "rma-seed-1", ref: "RMA-2026-001", refNum: 1, refYear: 2026,
    stage: "with_manufacturer", status: "dispatched", stageEnteredAt: iso(41),
    closedAt: null, closedBy: null,
    deviceIds: [2001, 2002],
    faultDescriptions: { 2001: "Buttons — left button unresponsive", 2002: "Buttons — left button very stiff" },
    faultMode: "single", faultCategory: "Buttons", faultCategories: {},
    manufacturer: "Lightbug", carrier: "Hand delivered", trackingNumber: "1Z999AA10123456784",
    slaDays: 30, expectedBackAt: iso(11), outcomes: {},
    createdAt: iso(41), createdBy: "Oliver Watts",
    dispatchedAt: iso(41), dispatchedBy: "Oliver Watts",
    returnedAt: null, returnedBy: null,
    activity: [
      { at: iso(3), by: "Oliver Watts", kind: "chased", text: "Chase email sent to Lightbug support" },
      { at: iso(41), by: "Oliver Watts", kind: "dispatched", text: "Dispatched via Hand delivered · 1Z999AA10123456784" },
      { at: iso(41), by: "Oliver Watts", kind: "raised", text: "RMA raised with 2 units" },
    ],
    lastChasedAt: iso(3), source: "quarantine", qcSessionId: null, importBatch: null,
  },
  {
    id: "rma-seed-2", ref: "RMA-2026-002", refNum: 2, refYear: 2026,
    stage: "awaiting_dispatch", status: "preparing", stageEnteredAt: iso(3),
    closedAt: null, closedBy: null,
    deviceIds: [2003],
    faultDescriptions: { 2003: "Accuracy check — will not hold RTK fix on open site" },
    faultMode: "single", faultCategory: "Accuracy check", faultCategories: {},
    manufacturer: "Lightbug", carrier: "", trackingNumber: "",
    slaDays: 30, expectedBackAt: null, outcomes: {},
    createdAt: iso(3), createdBy: "Oliver Watts",
    dispatchedAt: null, dispatchedBy: null, returnedAt: null, returnedBy: null,
    activity: [{ at: iso(3), by: "Oliver Watts", kind: "raised", text: "RMA raised with 1 unit" }],
    lastChasedAt: null, source: "quarantine", qcSessionId: null, importBatch: null,
  },
  // Deliberately legacy-shaped: no ref, no stage, no outcomes. mergeState must migrate this
  // on load without renumbering the two records above.
  {
    id: "rma-seed-legacy", deviceIds: [2004],
    faultDescriptions: { 2004: "Housing condition — water ingress after site use" },
    trackingNumber: "1Z999AA10651200912", status: "dispatched",
    createdAt: iso(60), createdBy: "Oliver Watts",
    dispatchedAt: iso(59), dispatchedBy: "Oliver Watts",
    returnedAt: null, returnedBy: null,
  },
];

const seedQcSessions = [
  {
    id: "qcs-seed-1", importBatch: "PO-12480", type: "RH2",
    startedAt: iso(3), finishedAt: iso(3), by: "dev", byName: "Dev Seed",
    simType: "Webbing", simType2: "Webbing", purchaseDate: "2026-01-01",
    devices: [
      { deviceId: 2010, serial: "43000811", type: "RH2", result: "fail", checks: {}, failedChecks: ["Buttons", "Haptics"], note: "Right button dead out of the box, no haptic response", checkedAt: iso(3) },
      { deviceId: 2011, serial: "43000814", type: "RH2", result: "fail", checks: {}, failedChecks: ["Charging"], note: "Will not charge from supplied cable or bench PSU", checkedAt: iso(3) },
      { deviceId: 1000, serial: "43000125", type: "RH2", result: "pass", checks: {}, failedChecks: [], note: "", checkedAt: iso(3) },
      { deviceId: 1001, serial: "43000117", type: "RH2", result: "pass", checks: {}, failedChecks: [], note: "", checkedAt: iso(3) },
    ],
  },
  {
    id: "qcs-seed-2", importBatch: "PO-12461", type: "RH2",
    startedAt: iso(16), finishedAt: iso(16), by: "dev", byName: "Dev Seed",
    simType: "Webbing", simType2: "Webbing", purchaseDate: "2026-01-01",
    devices: [
      { deviceId: 2012, serial: "43000769", type: "RH2", result: "fail", checks: {}, failedChecks: ["Powers on"], note: "Dead on arrival, no response on charge", checkedAt: iso(16) },
      { deviceId: 1002, serial: "43000090", type: "RH2", result: "pass", checks: {}, failedChecks: [], note: "", checkedAt: iso(16) },
    ],
  },
];

// 44 Armband units, each with its own QR label: 30 unissued in the warehouse and
// 14 already out on the two live sites.
const seedConsumableStock = Array.from({ length: 44 }, (_, i) => {
  const onSite = i >= 30;
  const locationName = !onSite ? null : i < 39 ? "Fratton Station" : "Clapham Junction";
  return {
    id: "cs-seed-" + i,
    typeId: "ct-1",
    typeName: "Armband",
    serial: "",
    qrCode: "OWL-C-" + String(1000 + i),
    status: onSite ? "dispatched" : "in_stock",
    locationName,
    batchId: null,
    addedAt: "2026-08-14T09:00:00.000Z",
    addedBy: "Seed",
    retiredAt: null,
    notes: "",
  };
});

export const DEV_SEED_STATE = {
  devices: [...seedDevices, ...seedRmaDevices],
  testResults: [],
  testers: ["Ollie"],
  componentProfiles: [],
  deviceTypes: ["RH2", "RH1", "Teltonika"],
  testDefs: {
    RH2: [
      { id: "activation", label: "Device Activation", desc: "Does the device become active?", type: "passfail" },
      { id: "portal", label: "OWL Portal Visibility", desc: "Does it show on the OWL Portal?", type: "passfail" },
      { id: "geofence", label: "Geofence Alerting", desc: "Does it alert within a geofence?", type: "passfail" },
      { id: "haptics", label: "Haptics", desc: "Does the haptic motor work correctly?", type: "passfail" },
      { id: "piezo", label: "Piezo", desc: "Does the piezo buzzer work correctly?", type: "passfail" },
      { id: "accuracy", label: "Accuracy Check", desc: "Is the accuracy >0.01m?", type: "passfail" },
      { id: "reboots", label: "Reboots Required", desc: "How many reboots needed?", type: "number" },
    ],
    RH1: [
      { id: "activation", label: "Device Activation", desc: "Does the device become active?", type: "passfail" },
      { id: "portal", label: "OWL Portal Visibility", desc: "Does it show on the OWL Portal?", type: "passfail" },
      { id: "geofence", label: "Geofence Alerting", desc: "Does it alert within a geofence?", type: "passfail" },
      { id: "haptics", label: "Haptics", desc: "Does the haptic motor work correctly?", type: "passfail" },
      { id: "piezo", label: "Piezo", desc: "Does the piezo buzzer work correctly?", type: "passfail" },
      { id: "accuracy", label: "Accuracy Check", desc: "Is the accuracy >0.01m?", type: "passfail" },
      { id: "reboots", label: "Reboots Required", desc: "How many reboots needed?", type: "number" },
    ],
    Teltonika: [
      { id: "sdlc", label: "SDLC Visibility", desc: "Does it show up on SDLC?", type: "passfail" },
      { id: "reporting", label: "Reporting Interval", desc: "Reporting back within required timeframe?", type: "passfail" },
    ],
  },
  maintenanceJobs: [],
  employees: [],
  assignments: [],
  testDraft: null,
  sessions: [],
  managers: [],
  retirementRequests: [],
  userRoles: {},
  auditLog: [],
  forecasts: [],
  targetFirmware: {},
  autoFlashVersions: ["2561"],
  rmaShipments: seedRmaShipments,
  rmaCounters: { 2026: 2 },
  qcSessions: seedQcSessions,
  firmwareTestResults: [],
  firmwareSessions: [],
  // Armband is tracked individually (a QR code per unit, seeded below); the rest are
  // counted per location. Reorder points are fleet-wide, so Antenna sits below its
  // line and Armband just above it, which exercises both alert states on the screen.
  consumables: [
    { id: "ct-1", name: "Armband", tracked: true, hasSerials: true, reorderPoint: 40 },
    { id: "ct-2", name: "Antenna", tracked: false, hasSerials: false, reorderPoint: 120 },
    { id: "ct-3", name: "Charging Cable", tracked: false, hasSerials: false, reorderPoint: 300 },
    { id: "ct-4", name: "Carry Case", tracked: false, hasSerials: false, reorderPoint: 150 },
    { id: "ct-5", name: "Mag Mount", tracked: false, hasSerials: false, reorderPoint: 0 },
  ],
  consumableLocations: ["Warehouse", "Fratton Station", "Clapham Junction"],
  consumableQty: {
    Warehouse: { "ct-2": 74, "ct-3": 820, "ct-4": 300, "ct-5": 96 },
    "Fratton Station": { "ct-2": 12, "ct-3": 260, "ct-4": 72 },
    "Clapham Junction": { "ct-2": 18, "ct-3": 124, "ct-4": 40 },
  },
  consumableStock: seedConsumableStock,
  locations: [
    { id: "loc-1", name: "Onwave Office", customer: "Onwave", address: "", status: "Active", expectedCount: 0 },
    { id: "loc-2", name: "Fratton Station", customer: "SRE", address: "Portsmouth", status: "Active", expectedCount: 0 },
    { id: "loc-3", name: "Clapham Junction", customer: "Network Rail", address: "London", status: "Active", expectedCount: 0 },
  ],
  shifts: [
    {
      id: "shift-seed-1", locationId: "loc-2", possessionRef: "P4034438",
      title: "Farlington Jn \u2192 Portsmouth Harbour", site: "Fratton, Portsmouth",
      startAt: new Date(Date.now() - 4 * 3600000).toISOString(),
      endAt: new Date(Date.now() + 2 * 3600000).toISOString(),
      shiftNumber: 11, week: 53, supervisorUserId: "J. Reason",
      status: "active", anonymousMode: false, createdByUserId: "oliver.watts@onwave.com",
      createdAt: new Date(Date.now() - 24 * 3600000).toISOString(),
      startedAt: new Date(Date.now() - 4 * 3600000).toISOString(), closedAt: null,
    },
    {
      id: "shift-seed-2", locationId: "loc-2", possessionRef: "P4034438",
      title: "Farlington Jn \u2192 Portsmouth Harbour", site: "Fratton, Portsmouth",
      startAt: new Date(Date.now() + 20 * 3600000).toISOString(),
      endAt: new Date(Date.now() + 23 * 3600000).toISOString(),
      shiftNumber: 12, week: 53, supervisorUserId: "J. Reason",
      status: "planned", anonymousMode: false, createdByUserId: "oliver.watts@onwave.com",
      createdAt: new Date(Date.now() - 24 * 3600000).toISOString(),
      startedAt: null, closedAt: null,
    },
    {
      id: "shift-seed-3", locationId: "loc-3", possessionRef: "P4034439",
      title: "Clapham Jn \u2192 Waterloo", site: "Clapham Junction",
      startAt: new Date(Date.now() + 48 * 3600000).toISOString(),
      endAt: new Date(Date.now() + 51 * 3600000).toISOString(),
      shiftNumber: 9, week: 1, supervisorUserId: "O. Chadwick",
      status: "planned", anonymousMode: false, createdByUserId: "oliver.watts@onwave.com",
      createdAt: new Date().toISOString(),
      startedAt: null, closedAt: null,
    },
  ],
  allocations: [
    {
      id: "alloc-seed-1", shiftId: "shift-seed-1", deviceId: 1000,
      role: "COSS", operativeName: "D. Arren", operativePhone: "07732 217115",
      outAt: new Date(Date.now() - 3.5 * 3600000).toISOString(), inAt: null,
      status: "out", notes: null,
      swappedFromAllocationId: null, swappedToAllocationId: null, carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 3.5 * 3600000).toISOString(),
    },
    {
      id: "alloc-seed-2", shiftId: "shift-seed-1", deviceId: 1001,
      role: "MC", operativeName: "A. Aanya", operativePhone: "07228 356519",
      outAt: new Date(Date.now() - 3 * 3600000).toISOString(), inAt: null,
      status: "out", notes: null,
      swappedFromAllocationId: null, swappedToAllocationId: null, carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 3 * 3600000).toISOString(),
    },
    {
      id: "alloc-seed-3", shiftId: "shift-seed-1", deviceId: 1002,
      role: "COSS/Tamper", operativeName: "D. Brass", operativePhone: "07523 030478",
      outAt: new Date(Date.now() - 2.5 * 3600000).toISOString(),
      inAt: new Date(Date.now() - 1 * 3600000).toISOString(),
      status: "returned", notes: "Swapped for 43000092",
      swappedFromAllocationId: null, swappedToAllocationId: "alloc-seed-4", carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 2.5 * 3600000).toISOString(),
    },
    {
      id: "alloc-seed-4", shiftId: "shift-seed-1", deviceId: 1003,
      role: "COSS/Tamper", operativeName: "D. Brass", operativePhone: "07523 030478",
      outAt: new Date(Date.now() - 1 * 3600000).toISOString(), inAt: null,
      status: "out", notes: "Swapped from 43000090",
      swappedFromAllocationId: "alloc-seed-3", swappedToAllocationId: null, carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 1 * 3600000).toISOString(),
    },
    {
      id: "alloc-seed-5", shiftId: "shift-seed-1", deviceId: 1004,
      role: "RRV", operativeName: null, operativePhone: null,
      outAt: new Date(Date.now() - 2 * 3600000).toISOString(), inAt: null,
      status: "out", notes: null,
      swappedFromAllocationId: null, swappedToAllocationId: null, carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 2 * 3600000).toISOString(),
    },
    {
      id: "alloc-seed-6", shiftId: "shift-seed-1", deviceId: 1005,
      role: "COSS/CC", operativeName: "L. Cullrey", operativePhone: "07356 216710",
      outAt: new Date(Date.now() - 2.8 * 3600000).toISOString(), inAt: null,
      status: "out", notes: null,
      swappedFromAllocationId: null, swappedToAllocationId: null, carriedFromAllocationId: null,
      flaggedByUserId: null, flaggedAt: null, recoveredAt: null,
      createdByUserId: "oliver.watts@onwave.com", createdAt: new Date(Date.now() - 2.8 * 3600000).toISOString(),
    },
  ],
  userLocationScope: [
    { userId: "oliver.watts@onwave.com", locationId: "loc-2" },
    { userId: "oliver.watts@onwave.com", locationId: "loc-3" },
  ],
};

export const DEV_LS_KEY = "owl-dev-state";
